import React, { Component } from 'react';
import TextMap from '../../../helpers/TextMap';
import UserAvatar from '../../../components/UserAvatar';
import dataModel from '../../../models/DataModel';

import './AssignmentPullout.scss';

class AssignmentPullout extends Component {
  constructor(props) {
    super(props);
    
    this.textMap = new TextMap();
    this.queryCancel = this.queryCancel.bind(this);

    this.determineAssignmentInfo();
  }

  queryCancel() {
    const message = (
      <div>
        <p>{`You have selected ${this.assignedToType.toLowerCase()}s for assignment.`}</p>
        <p>Are you sure you want to cancel?</p>
      </div>
    );
    dataModel.showGlobalModal('SYSTEM_POPUP', {
      height: 180,
      message: message,
      cancelButtonText: 'No',
      okButtonText: 'Yes',
      handleOwnerOk: () => {
        this.props.handleCancel(true);
      },
    });
  }

  determineAssignmentInfo() {
    const { quickAssignments } = this.props;
    let assignmentType = '';
    let assignedToType = 'TASK';
    let numberTypes = 0;
    let foundType = null;
    let users = [];
    for (let key in quickAssignments) {
      if (key) {
        numberTypes++;
        foundType = key;
        if (key == 'build-owner' || key == 'build-notify') {
          assignedToType = 'BUILD';
        }
        for (var userId in quickAssignments[foundType]) {
          if (userId) {
            users.push(quickAssignments[foundType][userId]);
          }
        }
      }
    }
    this.numberTypes = numberTypes;
    if (numberTypes > 1) {
      assignmentType = numberTypes + ' ASSIGNMENT TYPES';
    }
    else {
      switch (foundType) {
      case 'field_user':
        assignmentType = 'ASSIGNED TO ';
        break;
      case 'reviewer':
        assignmentType = 'REVIEWER ';
        break;
      case 'approver':
        assignmentType = 'APPROVER ';
        break;
      case 'build-owner':
        assignmentType = 'BUILD OWNER';
        assignedToType = 'BUILD';
        break;
      case 'notify-task':
        assignmentType = 'NOTIFY';
        break;
      case 'build-notify':
        assignmentType = 'NOTIFY';
        assignedToType = 'BUILD';
        break;
      default:
        break;
      }
    }
    this.assignmentType = assignmentType;
    this.assignedToType = assignedToType;
    this.assignedToUsers = users;
  }

  render() {
    const { selectedCount } = this.props;

    if (!this.assignedToUsers) {
      return null;
    }

    const multiAssigned = this.assignedToUsers.length > 1;

    let selectedUser = this.assignedToUsers.length == 1 ? this.assignedToUsers[0] : { id: -1, first_name: 'Multiple', last_name: 'Users' };
    let instructionText = '';
    if (this.assignmentType == 'NOTIFY') {
      instructionText = <div className="instruction-text">
        {selectedUser.first_name.toUpperCase() + ' ' + selectedUser.last_name.toUpperCase() + ' WILL BE NOTIFIED AFTER THE COMPLETION OF '}
        <span className="instruction-text--bold">{selectedCount + ' ' + this.assignedToType + (selectedCount == 1 ? '' : 'S')}</span>
      </div>;
    }
    else if (this.assignedToUsers.length > 1 && this.numberTypes > 1) {
      instructionText = <div className="instruction-text">
        {'MULTIPLE USERS WILL BE ASSIGNED '}
        {' TO '}
        <span className="instruction-text--bold">{selectedCount + ' ' + this.assignedToType + (selectedCount == 1 ? '' : 'S')}</span>
      </div>;
    }
    else {
      instructionText = <div className="instruction-text">
        {selectedUser.first_name.toUpperCase() + ' ' + selectedUser.last_name.toUpperCase() + ' WILL BE THE '}
        <span className="instruction-text--bold">{this.assignmentType}</span>
        {' OF '}
        <span className="instruction-text--bold">{selectedCount + ' ' + this.assignedToType + (selectedCount == 1 ? '' : 'S')}</span>
      </div>;
    }

    return (
      <div className="assignment-pullout">
        <div className="avatar-holder">
          <UserAvatar user={selectedUser} extraLarge={true} multiAssigned={multiAssigned}/>
        </div>
        {instructionText}
        <div className={'save-button' + (selectedCount > 0 ? ' enabled' : '')} onClick={selectedCount > 0 ? this.props.handleSave : null}>
          {this.textMap.assign.toUpperCase()}
        </div>
        <div
          className="cancel-button"
          onClick={selectedCount > 0 ? this.queryCancel : () => this.props.handleCancel(true)}
        />
      </div>
    );
  }
}

export default AssignmentPullout;



// WEBPACK FOOTER //
// ./src/containers/ProjectsContainer/AssignmentPullout/index.js